const keywordMatch = [
    'Name containing',
    'Name starting with',
    'Name exact match',
    'UEN (Including previous UEN)',
];
const entityType = [
    'Local Companies',
    'Foreign Companies',
    'Businesses',
    'Limited Liability Partnerships',
    'Limited Partnerships',
    'Public Accounting Firms',
    'Variable Capital Companies',
];
const entityTypeCode = ['LC', 'FC', 'BIZ', 'LLP', 'LP', 'PAF', 'VC'];
const positionType = ['CPP', 'CP', 'PP'];
export const compareKeyword = (a, b) => keywordMatch.indexOf(a.label) - keywordMatch.indexOf(b.label);
export const compareEntity = (a, b) => entityType.indexOf(a.label) - entityType.indexOf(b.label);
export const comparePeoplePosition = (a, b) => positionType.indexOf(a === null || a === void 0 ? void 0 : a.code) - positionType.indexOf(b === null || b === void 0 ? void 0 : b.code);
export const sortCodeListByEntityTypeCode = (codeList) => {
    const sortedList = entityTypeCode
        .map((value) => codeList.find((item) => item.value === value))
        .filter((item) => item !== undefined);
    return sortedList.length > 0 ? sortedList : codeList;
};
export const handleOnChangeSsic = (values, filterSelection, setFilterSelection) => {
    setFilterSelection((prevState) => ({
        ...prevState,
        ssic: values.reduce((currentSsicValue, ssicValue) => {
            const item = filterSelection === null || filterSelection === void 0 ? void 0 : filterSelection.ssic.find((ssic) => ssic.id === ssicValue);
            if (item) {
                currentSsicValue.push(item);
            }
            return currentSsicValue;
        }, []),
    }));
};
export const handleSaveSsicOptions = (val, setFilterSelection) => {
    setFilterSelection((prevState) => ({
        ...prevState,
        ssic: val,
    }));
};
export const isValidEntityNameHistory = (entityNameHistory) => Array.isArray(entityNameHistory) &&
    entityNameHistory.length > 0 &&
    entityNameHistory.some((item) => item.entityName);
